import * as React from 'react';

import { FormattedMessage } from 'react-intl';

import { WalletTransactionType } from 'constants/wallet';
import { formatCurrency, formatDate } from 'helper/form';
import { WalletRedeemDetails, WalletTransaction } from 'models/wallet';

import './WalletHistoryItem.scss';

interface WalletHistoryItemProps {
  transaction: WalletTransaction;
}

export class WalletHistoryItem extends React.Component<WalletHistoryItemProps, {}> {
  render() {
    const { transaction } = this.props;

    return (
      <div className="wallet-history-item">
        <div className="wallet-history-item__logo o-title-1">
          <i className={this.getLogoClassName(transaction.amount)}/>
        </div>
        <div className="wallet-history-item__content">
          <div className="wallet-history-item__content-header">
            {this.renderSubject(transaction)}
          </div>
          <div className="wallet-history-item__content-footer">
            {this.renderAmount(transaction.amount)}
            <span className="wallet-history-item__content-footer-date">
              {formatDate(transaction.createdAt)}
            </span>
          </div>
        </div>
      </div>
    );
  }

  private renderAmount(amount: number) {
    const className = amount > 0 ?
    'wallet-history-item__content-amount-positive' :
    'wallet-history-item__content-amount-negative';
    return (
      <span className={className}>
        {formatCurrency(amount.toString())}
      </span>
    );
  }

  private renderSubject(transaction: WalletTransaction) {
    if (transaction.transactionType === WalletTransactionType.REDEEM) {
      const redeemDetails = transaction.transactionDetails as WalletRedeemDetails;
      return <FormattedMessage id="wallet.history.item.redeem.subject" values={{ bankName: redeemDetails.bank.name, redeemStatus: redeemDetails.redeemStatus }} />;
    } else {
      return transaction.subject;
    }
  }

  private getLogoClassName(amount: number) {
    return amount >= 0 ? 'ic-money-receive' : 'ic-money-out';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Wallet/WalletHistoryItem/WalletHistoryItem.tsx